import React from 'react';
import { Home, PartyPopper, Utensils, MenuSquare, Wine, Cake } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockData } from '../mock';

const iconMap = {
  home: Home,
  party: PartyPopper,
  utensils: Utensils,
  menu: MenuSquare,
  glass: Wine,
  cake: Cake
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-charcoal mb-4">
            Nos Services
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto mb-6"></div>
          <p className="text-lg text-charcoal/70 max-w-2xl mx-auto">
            Une gamme complète de prestations pour tous vos événements
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockData.services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 border-none bg-white overflow-hidden"
              >
                <CardContent className="p-8">
                  <div className="mb-6 flex justify-center">
                    <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center group-hover:bg-gold/20 transition-all duration-300 group-hover:scale-110">
                      <Icon className="w-8 h-8 text-gold" strokeWidth={1.5} />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-charcoal mb-3 text-center">
                    {service.title}
                  </h3>
                  <p className="text-charcoal/70 text-center leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;